// Three
import * as THREE from 'three';

export default class Camera {
	constructor({ sizes }) {
		// near is negative so a tilted view (intro) never slices the image plane
		// against the near clip — the depth slab spans well past the planes (z=-1).
		this.el = new THREE.OrthographicCamera(
			sizes.width / -2,
			sizes.width / 2,
			sizes.height / 2,
			sizes.height / -2,
			-2000,
			2000
		);

		// this.el = new THREE.PerspectiveCamera(
		// 	75,
		// 	sizes.width / sizes.height,
		// 	0.1,
		// 	10000
		// );
		// this.el.position.set(0, 0, 1.3);

		// this.el.fov = 2 * (180 / Math.PI) * Math.atan(1 / (2 * 1));
		this.el.position.set(0, -window.scrollY, 10);
	}

	resizeCamera(sizes) {
		this.el.left = sizes.width / -2;
		this.el.right = sizes.width / 2;
		this.el.top = sizes.height / 2;
		this.el.bottom = sizes.height / -2;
		// this.el.aspect = sizes.width / sizes.height;
		this.el.updateProjectionMatrix();
	}
}
